module.exports = __webpack_public_path__ + "img/pigc2.434fe8a4.jpg";